import { useContext, useState } from 'react';
import { toFormattedDate } from '../../../utilities/FormatHelpers';
import {CustomerContext} from "../CustomerContext";
import {useAsyncEffect} from "../../../hooks/UseAsyncEffect";
import CustomerProduct from "./CustomerProduct";
import {useNavigate} from "react-router-dom";

export default function CustomerAccount() {
    const navigate = useNavigate();
    const { customerId, customerInformationService } = useContext(CustomerContext);
    const [accounts, setAccounts] = useState<CustomerAccount[]>([]);

    useAsyncEffect(async () => {
        if(customerId != null) {
            const customerAccounts = await customerInformationService.getAccounts(customerId);
            setAccounts(customerAccounts);
        }
    }, [customerId]);
   
// TODO: Enable the view account button when this works - currently accountId iis not returned from the call to getAccounts 
    return (
        <>
            <h2>Accounts</h2>
            {!accounts || accounts.length == 0 ?
                <p>No accounts.</p> :
                <table className="ui compact table">
                    <thead>
                        <tr>
                            <th>Account Number</th>
                            <th>Association Date</th>
                            <th>Status</th>
                            <th>Product</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accounts.map((a: CustomerAccount) =>
                            <tr key={a.accountNumber}>
                                <td>{a.accountNumber}</td>
                                <td>{toFormattedDate(a.associationDate)}</td>
                                <td>{a.status}</td>
                                <td><CustomerProduct productId={a.productId}/></td>
                                <td>
                                    <button className="ui button primary" onClick={() => navigate(`/accounts/${a.accountId}/summary`)}>View Account</button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            }
        </>
    )
}